import { render, staticRenderFns } from "./PurchasesReport.vue?vue&type=template&id=043cc55c&"
import script from "./PurchasesReport.vue?vue&type=script&lang=js&"
export * from "./PurchasesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports